<div class="callout container-fluid section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="callout__container">
          <div class="row">
            <div class="col-md-8">
              <div class="callout__content-wrapper">
                <h2 [innerText]="block.data.ctaTitle"></h2>
                <div class="pb-3" [innerHTML]="block.data.ctaText"></div>
                <a
                  [href]="block.data.ctaButtonUrl"
                  [target]="block.data.externalLink ? '_blank' : ''"
                  class="btn btn-dark mt-4">{{block.data.ctaButtonText}}
                  <span class="btn-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_157_425)">
                  <path d="M14.865 1.5H3.135C2.23201 1.5 1.5 2.23201 1.5 3.135V14.865C1.5 15.768 2.23201 16.5 3.135 16.5H14.865C15.768 16.5 16.5 15.768 16.5 14.865V3.135C16.5 2.23201 15.768 1.5 14.865 1.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.25 1.5V16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 1.5V16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.5 9H16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.5 5.25H5.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.5 12.75H5.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 12.75H16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 5.25H16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_157_425">
                    <rect width="18" height="18" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
                </a>
              </div>
            </div>
            <div class="col-md-4 p-0 d-flex justify-content-center justify-content-md-end">
              <img class="callout__image" [src]="calloutImageURL" [alt]="block.data.ctaTitle">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
